class format {
  static monthNames = [
    'Januar',
    'Februar',
    'Marts',
    'April',
    'Maj',
    'Juni',
    'Juli',
    'August',
    'September',
    'Oktober',
    'November',
    'December'
  ]

  static weekdayNames = [
    'Mandag',
    'Tirsdag',
    'Onsdag',
    'Torsdag',
    'Fredag',
    'Lørdag',
    'Søndag'
  ]

  static date = dateToFormat => {
    let newDate = dateToFormat
    if (!(dateToFormat instanceof Date)) {
      const adjustedDate = dateToFormat && dateToFormat.split(' ').join('T')
      newDate = new Date(adjustedDate)
    }

    const weekdayDaySunday = newDate.getDay()
    const weekdayDay = weekdayDaySunday === 0 ? 6 : weekdayDaySunday - 1
    const weekday = format.weekdayNames[weekdayDay]
    const shortWeekday = weekday && weekday.substr(0, 3)
    const year = newDate.getFullYear()

    let day = newDate.getDate() + ''
    let month = newDate.getMonth() + 1
    let hours = newDate.getHours() + ''
    let minutes = newDate.getMinutes() + ''
    const monthName = format.monthNames[month - 1]
    const shortMonthName = monthName && monthName.substr(0, 3).toLowerCase()

    function addZeroInFront(value) {
      if (value.toString().length === 1) {
        return '0' + value
      }
      return value
    }

    month = addZeroInFront(month)
    day = addZeroInFront(day)
    hours = addZeroInFront(hours)
    minutes = addZeroInFront(minutes)

    return {
      day,
      month,
      unformatted: newDate,
      timeStamp: newDate && newDate.getTime(),
      weekdayDay,
      weekday: shortWeekday && shortWeekday.toUpperCase(),
      shortDate: `${day}/${month}-${year}`,
      date: `${day}. ${shortMonthName && shortMonthName}.`,
      year,
      fullDate: `${weekday}, d. ${day}. ${monthName &&
        monthName.toLowerCase()} ${year}`,
      monthName,
      time: `${hours}:${minutes}`,
      datepicker: `${year}-${month}-${day}`
    }
  }
}

export function formatPayment(payment) {
  const paymentDate = payment.captured_time
    ? format.date(payment.captured_time.date)
    : payment.created_time && format.date(payment.created_time.date)

  return {
    provider: payment.provider.toLowerCase(),
    date: paymentDate && paymentDate.shortDate,
    time: paymentDate && paymentDate.time,
    completed: payment.callback_completed === '1',
    amount: payment.amount,
    currency: payment.currency,
    getTime: paymentDate && paymentDate.timeStamp
  }
}

export const formatCards = cards => {
  return cards.map(card => {
    return formatCard(card)
  })
}

export function formatCard(card) {
  const barcode = card.barcode
  const expired = card.expired
  const startTime = card.start_time ? format.date(card.start_time.date) : {}
  const stopTime = card.stop_time ? format.date(card.stop_time.date) : {}

  let subscription_active = undefined
  let amount = undefined
  let currency = undefined
  let provider = undefined

  if (card.payment) {
    subscription_active = card.payment.subscription_active === '1'
    amount = card.payment.amount
    currency = card.payment.currency
    provider = card.payment.provider.toLowerCase()
  }

  const active = provider === 'cash' || subscription_active

  return {
    ...card,
    barcode,
    expired,
    startTime,
    stopTime,
    subscription_active,
    amount,
    currency,
    provider,
    active
  }
}

export function formatTickets(ticketsArray, pass = 'annual') {
  const nowTime = new Date().getTime()

  let tickets = {}
  let ticketStats = {
    comingShows: 0,
    completedShows: 0,
    noshowShows: 0
  }
  let totalShows = 0

  ticketsArray.forEach(ticket => {
    let count = ticket[pass + '_count']
    let noshow = ticket[pass + '_noshow']

    const showDate = format.date(ticket.show_date.date)
    const bookingDate = format.date(ticket.booking_date.date)
    const id =
      ticket.elektra_order_no +
      '' +
      ticket.elektra_suborder_no +
      '' +
      ticket.elektra_card_id

    tickets = {
      ...tickets,
      [id]: {
        id,
        finished: ticket.finished,
        eventName: ticket.event_name,
        elektra_event_no: ticket.elektra_event_no,
        elektra_order_no: ticket.elektra_order_no,
        elektra_suborder_no: ticket.elektra_suborder_no,
        elektra_card_id: ticket.elektra_card_id,
        elektra_show_no: ticket.elektra_show_no,
        showDate,
        bookingDate,
        totalPrice: ticket.price,
        currency: ticket.currency,
        annualTicketsCount: count,
        annualTicketsNoshow: noshow,
        regularTicketsCount: ticket.count,
        regularTicketsNoshow: ticket.noshow,
        card_barcode: ticket.card_barcode
      }
    }

    if (nowTime < showDate.timeStamp) {
      ticketStats = {
        ...ticketStats,
        comingShows: ticketStats.comingShows + count
      }
    } else {
      ticketStats = {
        ...ticketStats,
        noshowShows: ticketStats.noshowShows + noshow,
        completedShows: ticketStats.completedShows + count - noshow
      }
    }
    totalShows =
      ticketStats.comingShows +
      ticketStats.completedShows +
      ticketStats.noshowShows
  })

  return {
    tickets,
    ticketStats,
    totalShows
  }
}

const formatLocation = ({ address = null, ...location }) => {
  let formattedArea = ''

  // FORMAT AREA
  if (location.postal) {
    formattedArea += location.postal + ' '
  }
  if (location.city) {
    formattedArea += location.city
  }
  if (location.region) {
    formattedArea += ', ' + location.region
  }
  if (location.country) {
    formattedArea += ', ' + location.country
  }

  return {
    ...location,
    street: address,
    formattedArea
  }
}

export const formatDebitor = debitor => {
  return {
    name: debitor.name,
    picture: debitor.picture,
    email: debitor.email,
    elektra_debitor_id: debitor.elektra_debitor_id,
    telephone_country_code: debitor.telephone_country_code,
    telephone_number: debitor.telephone_number,
    telephone: debitor.telephone,
    mobile_country_code: debitor.mobile_country_code,
    mobile_number: debitor.mobile_number,
    mobile: debitor.mobile,
    location: debitor.location
      ? formatLocation(debitor.location)
      : { address: '', street: '', postal: '', city: '', formattedArea: '' }
  }
}

export const formatPassHolder = annualPassHolder => {
  const id = annualPassHolder.member_id
  return {
    id,
    member_id: id,
    debitor_id: annualPassHolder.debitor_id,
    active: annualPassHolder.active === 1,
    imported: annualPassHolder.imported === 1,
    ...(annualPassHolder.debitor && formatDebitor(annualPassHolder.debitor)),
    cards: annualPassHolder.cards ? formatCards(annualPassHolder.cards) : [],
    payments: []
  }
}
